import React from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/css/index.css";
import RouteSwitch from "./Router";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouteSwitch />
  </React.StrictMode>
);
